import React from 'react';
import PropTypes from 'prop-types';
import {TableRowStyle} from './Table.styled';
import {TableColumns} from './';

export const TableRow = React.memo(function TableRow({
	children,
	cy,
	hoverStyle,
	canExpandRow,
	isHeader,
	onClick,
	...tableColumnProps
}) {
	const rowExpandable = canExpandRow !== undefined ? canExpandRow : tableColumnProps.canExpand;
	const rowIsHeader = isHeader || tableColumnProps.isHeader;
	const handleClick = e => {
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};
	return (
		<TableRowStyle
			hoverStyle={hoverStyle}
			isHeader={rowIsHeader}
			canExpand={rowExpandable}
			level={tableColumnProps.level}
			hasGroupings={tableColumnProps.hasGroupings}
			data-cy={cy}
			clickHandled={!!onClick}
			onClick={handleClick}
		>
			<TableColumns {...tableColumnProps} isHeader={rowIsHeader} canExpandRow={rowExpandable}>
				{children}
			</TableColumns>
		</TableRowStyle>
	);
});

TableRow.propTypes = {
	children: PropTypes.node,
	isHeader: PropTypes.bool,
	cy: PropTypes.string,
	hoverStyle: PropTypes.object,
	canExpandRow: PropTypes.bool,
	onClick: PropTypes.func,
};
